import { t } from "../lib/i18n";
import React from 'react';
import { Link } from 'react-router-dom';

interface RecentActivitySectionProps {
  activities: any[];
  limit?: number; // New optional prop
}

const RecentActivitySection: React.FC<RecentActivitySectionProps> = ({
  activities,
  limit,
}) => {
  const displayLimit = limit || 5; // Use provided limit or default to 5
  const displayedActivities = activities.slice(0, displayLimit);
  const hasMoreActivities = activities.length > displayLimit;

  return (
    <div className="bg-bg-secondary p-4 rounded shadow border border-border-primary mb-6">
      <h3 className="text-xl font-bold mb-4 text-text-secondary">{t("recentActivitySection.k1")}</h3>
      {displayedActivities.length > 0 ? (
        <div className="space-y-3">
          {displayedActivities.map((activity, index) => (
            <div key={index} className="flex items-center justify-between bg-bg-tertiary p-3 rounded-lg border border-border-secondary">
              <div className="flex flex-col">
                <span className="text-sm text-text-secondary">
                  {new Date(activity.created_at).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' })}
                </span>
                <span className="text-base font-medium text-text-primary">
                  {activity.description}
                  {activity.property_custom_id && ` (Property: ${activity.property_custom_id})`}
                  {!activity.property_custom_id && activity.property_system_id && ` (Property ID: ${activity.property_system_id.substring(0, 8)}...)`}
                  {activity.lease_custom_id && ` (Lease: ${activity.lease_custom_id})`}
                  {!activity.lease_custom_id && activity.lease_system_id && ` (Lease ID: ${activity.lease_system_id.substring(0, 8)}...)`}
                </span>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <p className="text-text-secondary">{t("recentActivitySection.k2")}</p>
      )}
      {hasMoreActivities && (
        <div className="mt-4 text-right">
          <Link to="/activities" className="text-primary hover:underline">{t("recentActivitySection.k3")}</Link>
        </div>
      )}
    </div>
  );
};

export default RecentActivitySection;
